export default __webpack_public_path__ + "static/media/twitter.c697d3a3.svg";